






import Vue from 'vue'
export default Vue.extend({
  name: 'SquareButton',
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
      validator: function(value: string) {
        return ['primary', 'reverse', 'gray'].indexOf(value) !== -1
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    getColorType(): string {
      switch (this.color) {
        case 'primary':
          return '--primary'
        case 'reverse':
          return '--reverse'
        case 'gray':
          return '--gray'
        default:
          return '--primary'
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
})
